import { render, staticRenderFns } from "./EmojiList.vue?vue&type=template&id=2e97fc75&"
import script from "./EmojiList.vue?vue&type=script&lang=js&"
export * from "./EmojiList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_gwqqbdtstrkazc3c5tmodvvd2i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports